"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function PatientVoices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    author: "Jacqueline S.",
    quote: "\"Es war für mich ein absoluter Glückstreffer, Renata zu finden. Ich fühlte mich ab dem ersten Moment gut aufgehoben und verstanden. Sogar ohne dass ich Ihr etwas sagen musste, spürte sie intuitiv, wobei ich Unterstützung benötigte. Dank ihr haben sich viele wichtige Bereiche in meinem Leben verbessert. Ich kann sie von herzen empfehlen”",
    position: "Klientin",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/avatar_elena_s.png"
  }, {
    author: "Miriam K.",
    quote: "\"Renata hat eine besondere Gabe. Ich schätze mich sehr glücklich sie zu kennen und mich immer mal wieder von ihr zu behandeln lassen. Sie öffnet mir die Augen und hilft wieder Klarheit und Energie zu spüren. Die Behandlungen sind unglaublich wohltuend. Danach fühle ich mich völlig geerdet und leicht.”",
    position: "Klientin",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/avatar_marc_b.png"
  }, {
    author: "Miss Schnobrich",
    quote: "\"Einfühlsam, humorvoll, motiviert und mit guten Worten. Unglaublich was ich und meine Tochter für eine Entwicklung gemacht haben. Meine Tochter mächtig unter Druck, mit Essproblemen und Selbstverletzung, ist heute fast Symptom frei. Auch ich gehe meinen Weg unbeschwerter und Leichter.\"\xA0",
    position: "Klientin",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/avatar_sophie_r.png"
  }];
  return <section data-section-id="47552" id="stimmen-der-wandlung" ref={ref} className={cn("bg-background text-foreground relative w-full overflow-hidden py-24 lg:py-32 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-0 left-0 h-full w-full overflow-hidden opacity-10 pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-primary/20 blur-[120px]" />
        <div className="absolute top-[40%] -right-[10%] h-[500px] w-[500px] rounded-full bg-primary/20 blur-[100px]" />
      </div>

      <div className="container relative mx-auto px-6 md:px-12">
        <div className="mb-12 text-center">
          <h2 className="text-primary/70 text-sm font-medium uppercase tracking-[0.2em]">
            Stimmen der Wandlung
          </h2>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="mx-auto max-w-4xl">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center px-4 text-center md:px-10">
                  <Quote className="text-primary/10 mb-8 h-12 w-12 md:h-16 md:w-16" />
                  
                  <blockquote className="mb-10 max-w-3xl">
                    <p className="font-serif leading-tight italic text-foreground/90 !text-4xl">
                      &ldquo;{testimonial.quote}&rdquo;
                    </p>
                  </blockquote>

                  <div className="flex flex-col items-center gap-4">
                    
                    <div className="text-center">
                      <div className="text-lg font-medium tracking-tight">
                        {testimonial.author}
                      </div>
                      <div className="text-muted-foreground text-sm font-sans">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-12 flex justify-center gap-4 md:absolute md:top-1/2 md:mt-0 md:w-full md:-translate-y-1/2 md:justify-between md:px-0">
            <CarouselPrevious className="static translate-y-0 border-primary/20 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 md:absolute md:-left-16 md:translate-y-0" variant="outline" />
            <CarouselNext className="static translate-y-0 border-primary/20 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 md:absolute md:-right-16 md:translate-y-0" variant="outline" />
          </div>
        </Carousel>
      </div>
    </section>;
}